<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-robot-add`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 4a1 1 0 011-1h6a1 1 0 011 1v4a1 1 0 01-1 1h-1v4h13a2 2 0 012 2v9h-4v-7H11v22h16v4H9a2 2 0 01-2-2V15a2 2 0 012-2h13V9h-1a1 1 0 01-1-1V4zM0 25a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1H1a1 1 0 01-1-1v-6zm21 0h-6v6h6v-6zm17 4a1 1 0 00-1 1v5h-5a1 1 0 00-1 1v2a1 1 0 001 1h5v5a1 1 0 001 1h2a1 1 0 001-1v-5h5a1 1 0 001-1v-2a1 1 0 00-1-1h-5v-5a1 1 0 00-1-1h-2zm-5-4h-6v6h6v-6z"/></svg>
</template>
<script>

export default {
  name: 'IconRobotAdd',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
